import React from 'react'
import { Link, Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import Home from './sections/Home'
import Navbar from './sections/Navbar'
import About from './sections/About'
import Skills from './sections/Skills'
import Work from './sections/Work'
import Contact from './sections/Contact'
import ProjectSection from './components/ProjectSection'
import ExperienceSection from './sections/ExperienceSection'
import BlogSection from './sections/Blog'
import NotFoundPage from './components/NotFound'

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/experience' element={<ExperienceSection />} />
        <Route path='/projects' element={<ProjectSection />} />
        <Route path='/articles' element={<BlogSection />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App
